module.exports = __webpack_public_path__ + "img/testA3.4f367ad9.webp";